import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_CHECKBOX_CHECKED_SCHEMA = Object.freeze({
  CHECKBOX_IDENTIFIER: '',
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_CHECKBOX_CHECKED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_CHECKBOX_CHECKED_SCHEMA);

export class CheckboxCheckedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.checkbox_checked;
  }

  get properties() {
    return this.toJS();
  }
}
